export default function CryptoFundingSourcesLogo({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      width="128"
      height="128"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M53.8242 13L36.6355 25.8125L39.8319 18.2617L53.8242 13Z"
        fill="#E17726"
      />
      <path
        d="M14.1752 13L31.2109 25.9321L28.1677 18.2617L14.1752 13Z"
        fill="#E27625"
      />
      <path
        d="M47.6352 42.7078L43.0618 49.7461L52.8547 52.4624L55.6601 42.8616L47.6352 42.7078Z"
        fill="#E27625"
      />
      <path
        d="M12.3579 42.8614L15.1461 52.4621L24.9221 49.7459L20.3656 42.7075L12.3579 42.8614Z"
        fill="#E27625"
      />
      <path
        d="M24.395 30.8178L21.6748 34.952L31.3657 35.3962L31.0427 24.89L24.395 30.8178Z"
        fill="#E27625"
      />
      <path
        d="M43.6058 30.818L36.8562 24.7705L36.6352 35.3964L46.3261 34.9522L43.6058 30.818Z"
        fill="#E27625"
      />
      <path
        d="M24.9221 49.7459L30.7865 46.893L25.7371 42.9296L24.9221 49.7459Z"
        fill="#E27625"
      />
      <path
        d="M37.2132 46.893L43.0618 49.7461L42.2626 42.9296L37.2132 46.893Z"
        fill="#E27625"
      />
      <path
        d="M43.0618 49.7461L37.2132 46.893L37.6891 50.7204L37.6381 52.3434L43.0618 49.7461Z"
        fill="#D5BFB2"
      />
      <path
        d="M24.921 49.7467L30.3616 52.3434L30.3275 50.7204L30.7865 46.893L24.921 49.7467Z"
        fill="#D5BFB2"
      />
      <path
        d="M30.4637 40.4017L25.6012 38.9667L29.0355 37.3779L30.4637 40.4017Z"
        fill="#233447"
      />
      <path
        d="M37.5378 40.4017L38.966 37.378L42.4173 38.9668L37.5378 40.4017Z"
        fill="#233447"
      />
      <path
        d="M24.9199 49.7459L25.77 42.7075L20.3635 42.8614L24.9199 49.7459Z"
        fill="#CC6228"
      />
      <path
        d="M42.2282 42.7075L43.0618 49.7461L47.6347 42.8614L42.2282 42.7075Z"
        fill="#CC6228"
      />
      <path
        d="M46.3261 34.9522L36.6352 35.3964L37.5363 40.4017L38.9645 37.3778L42.4158 38.9666L46.3261 34.9522Z"
        fill="#CC6228"
      />
      <path
        d="M25.6012 38.9667L29.0355 37.3779L30.4637 40.4017L31.3657 35.3962L21.6748 34.952L25.6012 38.9667Z"
        fill="#CC6228"
      />
      <path
        d="M21.6748 34.952L25.7371 42.9296L25.6012 38.9667L21.6748 34.952Z"
        fill="#E27525"
      />
      <path
        d="M42.4173 38.9668L42.264 42.9297L46.3274 34.9517L42.4173 38.9668Z"
        fill="#E27525"
      />
      <path
        d="M31.3657 35.3962L30.4651 40.4014L31.6042 46.3121L31.8593 38.5222L31.3657 35.3962Z"
        fill="#E27525"
      />
      <path
        d="M36.6352 35.3964L36.1601 38.5052L36.3981 46.3121L37.5378 40.4017L36.6352 35.3964Z"
        fill="#E27525"
      />
      <path
        d="M37.5378 40.4017L36.3981 46.3121L37.2132 46.893L42.264 42.9297L42.4173 38.9668L37.5378 40.4017Z"
        fill="#F5841F"
      />
      <path
        d="M25.6012 38.9667L25.7371 42.9296L30.7865 46.893L31.6028 46.3125L30.4637 40.4017L25.6012 38.9667Z"
        fill="#F5841F"
      />
      <path
        d="M37.6381 52.3434L37.6891 50.7204L37.2472 50.3441H30.7526L30.3275 50.7204L30.3616 52.3434L24.921 49.7467L26.8252 51.3179L30.6846 54H37.2981L41.1745 51.3179L43.0618 49.7461L37.6381 52.3434Z"
        fill="#C0AC9D"
      />
      <path
        d="M37.2132 46.893L36.3966 46.3125L31.6028 46.3125L30.7865 46.893L30.3275 50.7204L30.7526 50.3441H37.2472L37.6891 50.7204L37.2132 46.893Z"
        fill="#161616"
      />
      <path
        d="M54.5548 26.6495L56 19.5771L53.8242 13L37.2132 25.3855L43.6058 30.818L52.6336 33.4659L54.6228 31.1255L53.7558 30.4933L55.1328 29.2292L54.0788 28.4092L55.456 27.35L54.5548 26.6495Z"
        fill="#763E1A"
      />
      <path
        d="M12 19.5771L13.4621 26.6495L12.5271 27.35L13.9212 28.4092L12.8671 29.2292L14.2442 30.4933L13.3771 31.1255L15.3663 33.4659L24.395 30.8178L30.7868 25.3855L14.1752 13L12 19.5771Z"
        fill="#763E1A"
      />
      <path
        d="M52.635 33.4661L43.6071 30.8182L46.3274 34.9517L42.264 42.9297L47.6365 42.8619L55.6601 42.8616L52.635 33.4661Z"
        fill="#F5841F"
      />
      <path
        d="M24.395 30.8178L15.3663 33.4659L12.3579 42.8614L20.3656 42.8619L25.7371 42.9296L21.6748 34.952L24.395 30.8178Z"
        fill="#F5841F"
      />
      <path
        d="M36.6366 35.3966L37.2147 25.3857L39.8319 18.2617L28.1698 18.262L30.7868 25.3855L31.3657 35.3962L31.5871 38.5399L31.6042 46.3121H36.3981L36.4156 38.5399L36.6366 35.3966Z"
        fill="#F5841F"
      />
      <path
        d="M53.8242 13L36.6355 25.8125L39.8319 18.2617M53.8242 13L39.8319 18.2617M53.8242 13L56 19.5771L54.5548 26.6495L55.456 27.35L54.0788 28.4092L55.1328 29.2292L53.7558 30.4933L54.6228 31.1255L52.6336 33.4659L43.6058 30.818M53.8242 13L37.2132 25.3855L43.6058 30.818M39.8319 18.2617L37.2147 25.3857L36.6366 35.3966L36.4156 38.5399L36.3981 46.3121M39.8319 18.2617L28.1698 18.262L30.7868 25.3855M14.1752 13L31.2109 25.9321L28.1677 18.2617L14.1752 13ZM14.1752 13L30.7868 25.3855M14.1752 13L12 19.5771L13.4621 26.6495L12.5271 27.35L13.9212 28.4092L12.8671 29.2292L14.2442 30.4933L13.3771 31.1255L15.3663 33.4659M43.0618 49.7461L47.6352 42.7078L55.6601 42.8616M43.0618 49.7461L52.8547 52.4624L55.6601 42.8616M43.0618 49.7461L37.2132 46.893M43.0618 49.7461L42.2626 42.9296L37.2132 46.893M43.0618 49.7461L37.6381 52.3434L37.6891 50.7204M43.0618 49.7461L42.2282 42.7075L47.6347 42.8614L43.0618 49.7461ZM43.0618 49.7461L41.1745 51.3179L37.2981 54H30.6846L26.8252 51.3179L24.921 49.7467M55.6601 42.8616L47.6365 42.8619L42.264 42.9297M55.6601 42.8616L52.635 33.4661L43.6071 30.8182L46.3274 34.9517M12.3579 42.8614L15.1461 52.4621L24.9221 49.7459M12.3579 42.8614L20.3656 42.7075L24.9221 49.7459M12.3579 42.8614L15.3663 33.4659M12.3579 42.8614L20.3656 42.8619L25.7371 42.9296M24.9221 49.7459L30.7865 46.893M24.9221 49.7459L25.7371 42.9296M24.395 30.8178L21.6748 34.952M24.395 30.8178L31.0427 24.89L31.3657 35.3962M24.395 30.8178L15.3663 33.4659M24.395 30.8178L30.7868 25.3855M21.6748 34.952L31.3657 35.3962M21.6748 34.952L25.6012 38.9667M21.6748 34.952L25.7371 42.9296M31.3657 35.3962L30.4637 40.4017M31.3657 35.3962L30.4651 40.4014L31.6042 46.3121M31.3657 35.3962L31.8593 38.5222L31.6042 46.3121M31.3657 35.3962L30.7868 25.3855M31.3657 35.3962L31.5871 38.5399L31.6042 46.3121M43.6058 30.818L36.8562 24.7705L36.6352 35.3964M43.6058 30.818L46.3261 34.9522M36.6352 35.3964L46.3261 34.9522M36.6352 35.3964L37.5363 40.4017L38.9645 37.3778L42.4158 38.9666L46.3261 34.9522M36.6352 35.3964L36.1601 38.5052L36.3981 46.3121M36.6352 35.3964L37.5378 40.4017M30.7865 46.893L25.7371 42.9296M30.7865 46.893L30.3275 50.7204M30.7865 46.893L24.921 49.7467M30.7865 46.893L31.6028 46.3125M25.7371 42.9296L25.6012 38.9667M37.2132 46.893L37.6891 50.7204M37.2132 46.893L36.3981 46.3121M37.2132 46.893L42.264 42.9297M37.2132 46.893L36.3966 46.3125L31.6028 46.3125M37.6891 50.7204L37.2472 50.3441H30.7526L30.3275 50.7204M24.921 49.7467L30.3616 52.3434L30.3275 50.7204M30.4637 40.4017L25.6012 38.9667M30.4637 40.4017L29.0355 37.3779L25.6012 38.9667M30.4637 40.4017L31.6028 46.3125M37.5378 40.4017L38.966 37.378L42.4173 38.9668M37.5378 40.4017L42.4173 38.9668M37.5378 40.4017L36.3981 46.3121M42.4173 38.9668L42.264 42.9297M42.4173 38.9668L46.3274 34.9517M42.264 42.9297L46.3274 34.9517M31.6042 46.3121H36.3981M24.9199 49.7459L25.77 42.7075L20.3635 42.8614L24.9199 49.7459Z"
        stroke="#F5841F"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g clipPath="url(#clip0_3301_717)">
        <path d="M119 8H69V58H119V8Z" fill="#AB9FF2" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M90.7348 40.089C88.8727 42.9425 85.7523 46.5535 81.6002 46.5535C79.6373 46.5535 77.75 45.7454 77.75 42.2354C77.75 33.2963 89.9547 19.4585 101.279 19.4585C107.721 19.4585 110.288 23.928 110.288 29.0036C110.288 35.5185 106.06 42.9677 101.858 42.9677C100.524 42.9677 99.8695 42.2354 99.8695 41.0738C99.8695 40.7708 99.9198 40.4426 100.021 40.089C98.5861 42.5385 95.818 44.8111 93.2261 44.8111C91.3388 44.8111 90.3825 43.6243 90.3825 41.9577C90.3825 41.3516 90.5084 40.7203 90.7348 40.089ZM100.489 28.8275C100.489 30.3065 99.6168 31.046 98.6407 31.046C97.6498 31.046 96.792 30.3065 96.792 28.8275C96.792 27.3485 97.6498 26.609 98.6407 26.609C99.6168 26.609 100.489 27.3485 100.489 28.8275ZM106.035 28.8276C106.035 30.3066 105.162 31.0461 104.186 31.0461C103.195 31.0461 102.338 30.3066 102.338 28.8276C102.338 27.3487 103.195 26.6092 104.186 26.6092C105.162 26.6092 106.035 27.3487 106.035 28.8276Z"
          fill="#FFFDF8"
        />
      </g>
      <g clipPath="url(#clip1_3301_717)">
        <path
          d="M34.0413 105C27.9528 105 23.0206 100.077 23.0206 94C23.0206 87.9225 27.9528 83 34.0413 83C36.6419 83 39.1586 83.9204 41.1455 85.5983C43.1325 87.2762 44.4614 89.6032 44.8969 92.1671H56C55.0636 80.8729 45.5954 72 34.0413 72C21.8725 72 12 81.8546 12 94C12 106.145 21.8725 116 34.0413 116C45.594 116 55.065 107.127 56 95.8329H44.8969C44.4614 98.3968 43.1325 100.724 41.1455 102.402C39.1586 104.08 36.6419 105 34.0413 105Z"
          fill="#0052FF"
        />
      </g>
      <path
        d="M98.5619 111.435C98.6302 111.606 98.7491 111.751 98.9025 111.852C99.0559 111.953 99.2365 112.004 99.4201 112C99.6036 111.995 99.7813 111.934 99.9294 111.826C100.077 111.717 100.189 111.566 100.248 111.392L111.947 77.196C112.005 77.0365 112.016 76.8639 111.979 76.6984C111.942 76.5329 111.858 76.3814 111.739 76.2615C111.619 76.1416 111.467 76.0583 111.302 76.0214C111.136 75.9845 110.964 75.9955 110.804 76.0531L76.608 87.7517C76.4343 87.8113 76.283 87.9226 76.1744 88.0706C76.0657 88.2187 76.005 88.3964 76.0003 88.5799C75.9956 88.7635 76.0472 88.9441 76.1481 89.0975C76.249 89.2509 76.3944 89.3698 76.5648 89.4381L90.8371 95.1615C91.2883 95.3421 91.6983 95.6123 92.0422 95.9556C92.3862 96.299 92.6571 96.7084 92.8385 97.1593L98.5619 111.435Z"
        stroke="#29D755"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M111.733 76.269L92.043 95.957"
        stroke="#29D755"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <clipPath id="clip0_3301_717">
          <rect x="69" y="8" width="50" height="50" rx="12" fill="white" />
        </clipPath>
        <clipPath id="clip1_3301_717">
          <rect
            width="44"
            height="44"
            fill="white"
            transform="translate(12 72)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
